import React, { useEffect, useState } from "react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  Stack,
  Box,
  FormLabel,
  Input,
  Select,
  Spinner,
  Textarea,
  Text,
  useToast,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";

import { storage, getFirestoreApp } from "../firebase-config";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { useParams } from "react-router-dom";
import { ReactInputMask } from "react-input-mask";

const AddCarrosFiliais = ({ getCarros }) => {
  const { filialId } = useParams();

  useEffect(() => {
    filialId;
  }, [filialId]);

  const initialState = {
    Carro: {
      placa: "",
      modelo: "",
      ano: "",
      filial: `${filialId}`,
      p_revisao: "",
      u_km_registrado: "",
      u_revisao: "",
      u_troca_pneu: "",
      obs: "",
      status: "Ativo",
    },
  };

  const db = getFirestoreApp;
  const [isDisabled, setIsDisabled] = useState(false); // Desabilitar botão após submit para evitar duplicação
  const { isOpen, onOpen, onClose } = useDisclosure();
  const firstField = React.useRef();
  const toast = useToast();
  const [addData, AddSetData] = useState(initialState);
  const {
    Carro: {
      placa,
      modelo,
      ano,
      filial,
      p_revisao,
      u_km_registrado,
      u_revisao,
      u_troca_pneu,
      status,
      obs,
    },
  } = addData;

  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  // useEffect(() => {
  //   const uploadFile = () => {
  //     const name = new Date().getTime() + file.name;

  //     const storageRef = ref(storage, "CNHS/" + cnh + " - " + nome);
  //     const uploadTask = uploadBytesResumable(storageRef, file);

  //     uploadTask.on(
  //       "state_changed",
  //       (snapshot) => {
  //         const progress =
  //           (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  //         setProgress(progress);
  //         switch (snapshot.state) {
  //           case "paused":
  //             console.log("Upload is pause");
  //             break;
  //           case "running":
  //             console.log("Upload is running");
  //             break;
  //           default:
  //             break;
  //         }
  //       },
  //       (error) => {
  //         console.log(error);
  //       },
  //       () => {
  //         getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //           setCnh_image((prev) => ({ ...prev, img: downloadURL }));
  //         });
  //       }
  //     );
  //   };
  //   file && uploadFile();
  // }, [file]);

  const handleChange = (e) => {
    AddSetData({
      ...addData,
      Carro: {
        ...addData.Carro,
        [e.target.name]: e.target.value,
      },
    });
  };

  async function createcar() {
    setIsDisabled(true);
    const docRef = await addDoc(
      collection(db, "/FILIAIS/91IYpjJbXYN99Asq2Enw", filialId),
      {
        ...addData,
        created_at: serverTimestamp(),
      }
    );
    onClose();
    ToastCarroCriado();
    getCarros(); // window.location.reload();
    handleReset();
    setIsDisabled(false);
  }

  const handleReset = () => {
    AddSetData(initialState);
  };
  const ToastCarroCriado = () => {
    return toast({
      title: "Carro criado com sucesso!",
      position: "bottom",
      status: "success",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  return (
    <>
      {isSubmit ? (
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
      ) : null}

      <Button leftIcon={<AddIcon />} colorScheme="green" onClick={onOpen}>
        Adicionar Veículo
      </Button>
      <Drawer
        isOpen={isOpen}
        size="lg"
        placement="bottom"
        initialFocusRef={firstField}
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px" pt={20}>
            ADCIONAR NOVO VEÍCULO:
          </DrawerHeader>

          <DrawerBody>
            <Stack spacing="15px">
              <Box>
                <FormLabel htmlFor="placa">Placa:</FormLabel>
                <Input
                  // ref={firstField}
                  id="placa"
                  name="placa"
                  data-object="Carro"
                  placeholder="Ex: XYZ-1057"
                  variant="filled"
                  value={placa}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <FormLabel htmlFor="modelo">Modelo:</FormLabel>
                <Input
                  id="modelo"
                  name="modelo"
                  data-object="Carro"
                  placeholder="Ex: Strada"
                  variant="filled"
                  value={modelo}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <FormLabel htmlFor="ano">Ano:</FormLabel>
                <Input
                  id="ano"
                  name="ano"
                  data-object="Carro"
                  placeholder="Ex: 2010 / 2011"
                  variant="filled"
                  value={ano}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <FormLabel htmlFor="p_revisao">Próxima revisão:</FormLabel>
                <Input
                  id="p_revisao"
                  name="p_revisao"
                  data-object="Carro"
                  placeholder=""
                  variant="filled"
                  value={p_revisao}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <FormLabel htmlFor="u_revisao">Última Revisão:</FormLabel>
                <Input
                  id="u_revisao"
                  name="u_revisao"
                  data-object="Carro"
                  placeholder=""
                  variant="filled"
                  value={u_revisao}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <FormLabel htmlFor="u_troca_pneu">
                  Última troca de pneu:
                </FormLabel>
                <Input
                  id="u_troca_pneu"
                  name="u_troca_pneu"
                  data-object="Carro"
                  placeholder=""
                  variant="filled"
                  value={u_troca_pneu}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <FormLabel htmlFor="u_km_registrado">
                  Último KM Registrado:
                </FormLabel>
                <Input
                  id="u_km_registrado"
                  name="u_km_registrado"
                  data-object="Carro"
                  placeholder=""
                  variant="filled"
                  value={u_km_registrado}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <FormLabel htmlFor="filial">Filial:</FormLabel>
                <Select
                  id="filial"
                  name="filial"
                  data-object="Carro"
                  variant="filled"
                  defaultValue={filial}
                  onChange={handleChange}
                >
                  <option>{filialId}</option>
                </Select>
              </Box>

              <Box>
                <FormLabel htmlFor="status">Status:</FormLabel>
                <Select
                  id="status"
                  name="status"
                  data-object="Carro"
                  variant="filled"
                  defaultValue={status}
                  onChange={handleChange}
                >
                  <option value="Ativo">Ativo</option>
                  <option value="Inativo">Inativo</option>
                  <option value="Manutenção">Manutenção</option>
                </Select>
              </Box>

              <Box>
                <Text mb="8px">Observação:</Text>
                <Textarea
                  name="obs"
                  placeholder="Coloque uma obsevação se necessário"
                  size="sm"
                  value={obs}
                  onChange={handleChange}
                />
              </Box>
            </Stack>
          </DrawerBody>

          <DrawerFooter borderTopWidth="1px">
            <Button variant="outline" mr={3} onClick={onClose}>
              SAIR
            </Button>
            <Button
              px={10}
              colorScheme="green"
              onClick={createcar}
              type="submit"
              disabled={isDisabled}
            >
              CADASTRAR
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default AddCarrosFiliais;
